
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';
import { AccountingPlanStatus } from 'enums/AccountingPlanStatus';


export class AccountingPlanRequestModel extends Model<AccountingPlanRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'accountingPlanId', type: 'string' },
		{ name: 'pausedRegistrations', type: 'boolean' },
		{ name: 'suspended', type: 'boolean' },
		{ name: 'ignorePriceAdjustments', type: 'boolean' }
	];
	[key: string]: any;
	
	public accountingPlanId?: string;
	public pausedRegistrations?: boolean;
	public suspended?: boolean;
	public ignorePriceAdjustments?: boolean;
    
	constructor(){
		super();
		this.accountingPlanId = undefined;
		this.pausedRegistrations = undefined;
		this.suspended = undefined;
		this.ignorePriceAdjustments = undefined;
		
	}
	getProperties(){
		return AccountingPlanRequestModel.classProperties;
	}
}
export class AccountingPlanSearchRequestModel extends Model<AccountingPlanSearchRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'companyIds', type: 'string[]', isArray: true },
		{ name: 'maxResults', type: 'number' },
		{ name: 'inActivePeriod', type: 'boolean' },
		{ name: 'isSuspended', type: 'boolean' },
		{ name: 'hasStartDate', type: 'boolean' },
		{ name: 'status', type: 'AccountingPlanStatus' }
	];
	[key: string]: any;
	
	public companyIds: string[];
	public maxResults?: number;
	public inActivePeriod?: boolean;
	public isSuspended?: boolean;
	public hasStartDate?: boolean;
	public status?: AccountingPlanStatus;
    
	constructor(){
		super();
		this.companyIds = [];
		this.maxResults = undefined;
		this.inActivePeriod = undefined;
		this.isSuspended = undefined;
		this.hasStartDate = undefined;
		this.status = undefined;
		
	}
	getProperties(){
		return AccountingPlanSearchRequestModel.classProperties;
	}
}
export class StartOfAccountingRequestModel extends Model<StartOfAccountingRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'products', type: 'ProductInfoModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductInfoModel }, properties: () => { return ProductInfoModel.classProperties } },
		{ name: 'companyId', type: 'string' },
		{ name: 'billingAddress', type: 'AddressModel', isHidden: true, isObject: true, new: () => { return new AddressModel }, properties: () => { return AddressModel.classProperties } },
		{ name: 'setStatus', type: 'AccountingPlanStatus' }
	];
	[key: string]: any;
	
	public products: ProductInfoModel[];
	public companyId?: string;
	public billingAddress?: AddressModel;
	public setStatus?: AccountingPlanStatus;
    
	constructor(){
		super();
		this.products = [];
		this.companyId = undefined;
		this.billingAddress = undefined;
		this.setStatus = undefined;
		
	}
	getProperties(){
		return StartOfAccountingRequestModel.classProperties;
	}
}
export class ProductInfoModel extends Model<ProductInfoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'productPlanId', type: 'string' },
		{ name: 'paymentScheme', type: 'number' },
		{ name: 'equalizingAmount', type: 'number' },
		{ name: 'startDate', type: 'Date' },
		{ name: 'endDate', type: 'Date' }
	];
	[key: string]: any;
	
	public productPlanId?: string;
	public paymentScheme: number;
	public equalizingAmount: number;
	public startDate?: Date;
	public endDate?: Date;
    
	constructor(){
		super();
		this.productPlanId = undefined;
		this.paymentScheme = 0;
		this.equalizingAmount = 0;
		this.startDate = undefined;
		this.endDate = undefined;
		
	}
	getProperties(){
		return ProductInfoModel.classProperties;
	}
}
export class CancellationRequestModel extends Model<CancellationRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'accountingPlanId', type: 'string' },
		{ name: 'discontinuedProductPlanIds', type: 'string[]', isArray: true }
	];
	[key: string]: any;
	
	public accountingPlanId?: string;
	public discontinuedProductPlanIds: string[];
    
	constructor(){
		super();
		this.accountingPlanId = undefined;
		this.discontinuedProductPlanIds = [];
		
	}
	getProperties(){
		return CancellationRequestModel.classProperties;
	}
}
export class AddressModel extends Model<AddressModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'companyName', type: 'string' },
		{ name: 'city', type: 'string' },
		{ name: 'streetAddress', type: 'string' },
		{ name: 'contactName', type: 'string' },
		{ name: 'emailAddress', type: 'string' },
		{ name: 'phoneNumber', type: 'string' },
		{ name: 'zipcode', type: 'string' },
		{ name: 'vatNumber', type: 'string' },
		{ name: 'glnNumber', type: 'string' }
	];
	[key: string]: any;
	
	public companyName: string;
	public city: string;
	public streetAddress: string;
	public contactName: string;
	public emailAddress: string;
	public phoneNumber: string;
	public zipcode: string;
	public vatNumber: string;
	public glnNumber: string;
    
	constructor(){
		super();
		this.companyName = '';
		this.city = '';
		this.streetAddress = '';
		this.contactName = '';
		this.emailAddress = '';
		this.phoneNumber = '';
		this.zipcode = '';
		this.vatNumber = '';
		this.glnNumber = '';
		
	}
	getProperties(){
		return AddressModel.classProperties;
	}
}

